import { useMemo } from 'react';
import StatusTag from '@/components/_common/StatusTag';
import {
  WorkOrderItemOrigin,
  WorkOrderItemType,
  workorderTypeColor,
  workorderTypeItem,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';

interface Props {
  workOrderItem: {
    type: WorkOrderItemType;
    origin?: WorkOrderItemOrigin;
    isInWomBasket?: boolean;
    isInPecaAiBasket?: boolean;
    isCourtesy?: boolean;
  };
}

export default function WorkOrderItemTypeTag({ workOrderItem }: Props) {
  const renderTag = useMemo(
    (): Record<string, React.ReactElement> => ({
      [WorkOrderItemType.Kit]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={`Kit`}
        />
      ),
      [WorkOrderItemType.Benefit]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={`Benefício${workOrderItem.isCourtesy ? ' - Cortesia' : ''}`}
        />
      ),
      [WorkOrderItemType.Bosch]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={`Bosch`}
        />
      ),
      [WorkOrderItemType.Porto]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={`Porto`}
        />
      ),
      [WorkOrderItemType.Part]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={
            workorderTypeItem[`${workOrderItem.type}/${workOrderItem.origin}`]
          }
        />
      ),
      [WorkOrderItemType.Service]: (
        <StatusTag
          color={workorderTypeColor[workOrderItem.type]}
          label={
            workorderTypeItem[`${workOrderItem.type}/${workOrderItem.origin}`]
          }
        />
      ),
    }),
    [workOrderItem],
  );

  const tagToRender = renderTag[workOrderItem.type];

  if (workOrderItem.isInWomBasket)
    return <StatusTag color="red" label="Bosch WOM" />;

  if (workOrderItem.isInPecaAiBasket)
    return <StatusTag color="orange" label="Peça Aí" />;

  if (tagToRender) return tagToRender;

  return <>{`-`}</>;
}
